import React, { useContext, useEffect, useState } from "react";
import { XCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import TopStats from "../Utility/TopStats";
import HeaderWithButton from "../Utility/HeaderWithButton";
import TopFilters from "../Utility/TopFilters";
import { Dialog } from "@headlessui/react";
import axios from "axios";
import { toast } from "react-toastify";
import LeadRoleList from "./LeadRoleList";
import { DataContext } from "../../helper/HelperOne";

function LeadRoleCreate() {
  const user = JSON.parse(localStorage.getItem("user"));
  const rolePermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 9 && access.label_value != 0
  );

  const [openLeadRoleDialog, setOpenLeadRoleDialog] = useState(false);
  const [saveBtn, setSaveBtn] = useState("");
  const [leadRoleData, setLeadRoleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editRoleIdCrypt, setEditRoleIdCrypt] = useState("");
  const { searchData } = useContext(DataContext);
  const [paginationLeadRole, setPaginationLeadRole] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const statsFieldNames = [
    "Total Lead Role",
    "Active Lead Role",
    "Inactive Lead Role",
  ];
  const [filterData, setFilterData] = useState({
    name: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    color: "#000000",
    permissions: {
      Customer: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        view: false,
      },
      Products: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        view: false,
      },
      Employee: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        view: false,
      },
      Lead: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        convertToCustomer: false,
        view: false,
      },
      LeadTask: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        discussion: false,
        view: false,
      },
      Quotation: {
        viewOwn: false,
        // viewGlobal: false,
        create: false,
        edit: false,
        delete: false,
        pdf: false,
        view: false,
      },
      Settings: {
        viewOwn: false,
        branch: false,
        taskStatus: false,
        taskPriority: false,
        leadStatus: false,
        leadSource: false,
        taskDiscussionStatus: false,
        quotationStatus: false,
        roles: false,
        rolesAssign: false,
      },
    },
  });

  const fetchLeadRoleData = async (page) => {
    try {
      const apiUrl = searchData
        ? `public/api/admin/leadrole/pagination?page=${page}&search=${searchData}`
        : `public/api/admin/leadrole/pagination?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setLeadRoleData(response.data.role.data);
      setPaginationLeadRole(response.data.role);
      if (response.data?.message) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching lead role data:", error);
      toast.error(error.response?.data?.message || "Failed to fetch role data");
    }
  };

  useEffect(() => {
    fetchLeadRoleData();
  }, [searchData]);

  const handleLeadRoleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      const [category, permission] = name.split(".");
      setFormData((prevData) => ({
        ...prevData,
        permissions: {
          ...prevData.permissions,
          [category]: {
            ...prevData.permissions[category],
            [permission]: checked,
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleAddRole = async () => {
    setLoading(true);
    setSaveBtn("save");
    try {
      setFormData({
        name: "",
        color: "#000000",
        permissions: {
          Customer: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            view: false,
          },
          Products: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            view: false,
          },
          Employee: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            view: false,
          },
          Lead: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            convertToCustomer: false,
            view: false,
          },
          LeadTask: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            discussion: false,
            view: false,
          },
          Quotation: {
            viewOwn: false,
            // viewGlobal: false,
            create: false,
            edit: false,
            delete: false,
            pdf: false,
            view: false,
          },
          Settings: {
            viewOwn: false,
            branch: false,
            taskStatus: false,
            taskPriority: false,
            leadStatus: false,
            leadSource: false,
            taskDiscussionStatus: false,
            quotationStatus: false,
            roles: false,
            rolesAssign: false,
          },
        },
      });
      await fetchLeadRoleData();
      setOpenLeadRoleDialog(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch role data");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = localStorage.getItem("token");

    const formattedPermissions = Object.entries(formData.permissions).reduce(
      (acc, [category, actions]) => {
        const formattedCategory = `${category.toLowerCase()}_role_based_access`;

        acc[formattedCategory] = Object.entries(actions).map(
          ([permission, value], index) => ({
            label_id: index + 1,
            label_value: value ? 1 : 0,
          })
        );
        return acc;
      },
      {}
    );

    // Final payload
    const payload = {
      name: formData.name,
      color: formData.color,
      ...formattedPermissions,
    };

    try {
      const response = await axios.post(
        "public/api/admin/leadrole/store",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        toast.success(response.data.message);
        setOpenLeadRoleDialog(false);
        await fetchLeadRoleData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch role data");
    }

    setLoading(false);
  };

  const handleUpdate = async (e, editRoleIdCrypt) => {
    e.preventDefault();

    setLoading(true);
    const token = localStorage.getItem("token");
    const formattedPermissions = Object.entries(formData.permissions).reduce(
      (acc, [category, actions]) => {
        const formattedCategory = `${category.toLowerCase()}_role_based_access`;

        acc[formattedCategory] = Object.entries(actions).map(
          ([permission, value], index) => ({
            label_id: index + 1,
            label_value: value ? 1 : 0,
          })
        );

        return acc;
      },
      {}
    );

    // Final payload
    const payload = {
      name: formData.name,
      color: formData.color,
      ...formattedPermissions,
    };

    try {
      const response = await axios.put(
        `public/api/admin/leadrole/update/${editRoleIdCrypt}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        toast.success(response.data.message);
        setOpenLeadRoleDialog(false);
        await fetchLeadRoleData();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update role data"
      );
    }

    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>
          <HeaderWithButton
            title="Lead Role"
            description="role"
            buttonText="Role"
            onButtonClick={handleAddRole}
            showButton={rolePermission}
          />

          {/* <TopFilters
            fields={fields}
            filterData={filterData}
            handleChange={handleChange}
            handleFilter={handleFilter}
            handleReset={handleReset}
          /> */}

          <LeadRoleList
            fetchLeadRoleData={fetchLeadRoleData}
            setLoading={setLoading}
            leadRoleData={leadRoleData}
            setOpenLeadRoleDialog={setOpenLeadRoleDialog}
            setFormData={setFormData}
            setEditRoleIdCrypt={setEditRoleIdCrypt}
            setSaveBtn={setSaveBtn}
            rolePermission={rolePermission}
            paginationLeadRole={paginationLeadRole}
            setCurrentPage={setCurrentPage}
          />

          {openLeadRoleDialog && (
            <Dialog
              open={openLeadRoleDialog}
              onClose={() => setOpenLeadRoleDialog(false)}
              className="fixed inset-0 z-50 flex items-center justify-center p-4"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className=" flex min-h-full items-end justify-center p-4 text-center sm:items-center  md:min-h-screen sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                    <div
                      className="flex justify-between p-4 text-white"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase">
                        Lead Roles
                      </h1>
                      <XMarkIcon
                        onClick={() => setOpenLeadRoleDialog(false)}
                        className="h-6 w-6 cursor-pointer"
                      />
                    </div>
                    <div className="relative max-w-7xl w-full p-6">
                      <div className="container mx-auto p-6 mt-4">
                        <div className="bg-white p-6 rounded-lg shadow-md">
                          <form className="space-y-4">
                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2">
                              <div className="mb-4">
                                <label
                                  htmlFor="name"
                                  className="block text-gray-700 font-semibold mb-1"
                                >
                                  Role Name{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="name"
                                  id="name"
                                  value={formData.name}
                                  onChange={handleLeadRoleChange}
                                  className="border border-gray-300 px-3 py-2 w-full rounded-md focus:outline-none focus:border-blue-500"
                                />
                              </div>

                              <div className="mb-4">
                                <label
                                  htmlFor="color"
                                  className="block text-gray-700 font-semibold mb-1"
                                >
                                  Role Color{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="color"
                                  name="color"
                                  id="color"
                                  value={formData.color}
                                  onChange={handleLeadRoleChange}
                                  className="border border-gray-300 w-full rounded-md focus:outline-none focus:border-blue-500"
                                />
                              </div>
                            </div>

                            {/* Permissions Table */}
                            <div className="overflow-x-auto">
                              <table className="w-full border border-gray-300 text-sm">
                                <thead>
                                  <tr className="bg-gray-200">
                                    <th className="border font-normal border-gray-300 p-2">
                                      Feature
                                    </th>
                                    <th className="border font-normal border-gray-300 p-2">
                                      Capabilities
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries(formData.permissions).map(
                                    ([category, actions]) => (
                                      <tr
                                        key={category}
                                        className="hover:bg-gray-50"
                                      >
                                        <td className="border border-gray-300 p-2">
                                          <p>{category}</p>
                                        </td>
                                        <td className="border border-gray-300 p-2 w-3/4">
                                          <div className="flex flex-wrap">
                                            {Object.entries(actions).map(
                                              ([permission, value]) => (
                                                <div
                                                  key={permission}
                                                  className="flex items-center mr-4 mb-2"
                                                >
                                                  <input
                                                    type="checkbox"
                                                    name={`${category}.${permission}`}
                                                    checked={value}
                                                    onChange={
                                                      handleLeadRoleChange
                                                    }
                                                    className="mr-2 border border-gray-400 rounded focus:ring-indigo-500"
                                                  />
                                                  <label className="mr-2">
                                                    {permission.replace(
                                                      /([A-Z])/g,
                                                      " $1"
                                                    )}{" "}
                                                    {/* Format names */}
                                                  </label>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* Submit Button */}
                            <div className="text-right">
                              {saveBtn === "save" ? (
                                <button
                                  onClick={handleSubmit}
                                  className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                  Save
                                </button>
                              ) : (
                                <button
                                  onClick={(e) =>
                                    handleUpdate(e, editRoleIdCrypt)
                                  }
                                  className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                  Update
                                </button>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default LeadRoleCreate;
